module.exports = __webpack_public_path__ + "img/C05TechLegionaryChampion_ua.c824ba38.webp";